<template>
   <v-dialog 
        v-model="isProfileDialogVisibleProxy" 
        persistent
        max-width="600px"
      >  
        <v-card>
          <v-form
            @submit.prevent="createOrEditProfile()"
            ref="formProfile"      
            v-model="isProfileFormValid"
            lazy-validation
          > 
            <v-card-title>{{ isEditMode ? 'Editar perfil' : 'Nuevo perfil' }}</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-if="!isEditMode"
                      v-model="profileData.Perfil"
                      :rules="[v => !!v || 'Nombre del perfil es obligatorio']"
                      outlined
                      label="Nombre del perfil"
                      required
                    />
                  </v-col>
                </v-row>
                
                <div
                  v-for="(modulo, moduloNombre) in profileData"
                  :key="moduloNombre"
                >
                  <div
                    v-if="!['id', 'Perfil', 'profile'].includes(moduloNombre)"
                    class="mt-4"
                  >
                    <h3 class="subtitle-1 font-weight-bold">{{ moduloNombre }}</h3>
                    <v-row>
                      <v-col
                        cols="6"
                        md="4"
                        v-for="(valor, permiso) in modulo"
                        :key="permiso"
                      >
                        <v-switch
                          v-model="profileData[moduloNombre][permiso]"
                          :label="permiso"
                          color="primary"
                        ></v-switch>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue darken-1"
                text
                @click="isProfileDialogVisibleProxy = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                :disabled="!isProfileFormValid"
                color="blue darken-1"
                text
                type="submit"
                :loading="isProfileButtonLoading"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
</template>
<script>
export default {
  name: 'ProfileDialog',

  props: {
    isProfileDialogVisible: {
      type: Boolean,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    profileData: {
      type: Object,
      required: true
    },
    isProfileFormValid: {
      type: Boolean,
      required: true
    },
    isProfileButtonLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isProfileDialogVisibleProxy: {
      get(){
        return this.isProfileDialogVisible
      },
      set(newValue){
       this.$emit("update:isProfileDialogVisible", newValue)
      }
    }
  },
  emits: ['update:isProfileDialogVisible', 'update:isProfileFormValid', 'submit-profile'],

  methods: {
    createOrEditProfile() {
      this.$emit('submit-profile', this.profileData);
    }
    
  }
};
</script>
